import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './Oripa.css'
import CommonModal from '../common/Modal/CommonModal'

import { useTranslation } from "react-i18next";

const NewOripaGeneral = ({moveNewOripaSelectCard, packageTypeList, packageInfo, setPackageInfo, shopInfo}) => {
  const { t } = useTranslation();

  const {shop} = useParams();

  const CreatePackageTypeSelectList = () => {
    return packageTypeList.map((packageType, index) => {
      return (
        <option key={"type"+index} value={packageType.package_type} {...packageInfo.packageType === packageType.package_type && {selected: true}}>
          {t('package_master.' + packageType.package_type_name)}
        </option>
      )
    })
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageEn, setPreviewImageEn] = useState(null);
  const [previewImageJp, setPreviewImageJp] = useState(null);

  const [previewPopImage, setPreviewPopImage] = useState(null);

  const [image, setImage] = useState(null);
  const [imageEn, setImageEn] = useState(null);
  const [imageJp, setImageJp] = useState(null);

  const [popImage, setPopImage] = useState(null);

  const [popImageDeleted, setPopImageDeleted] = useState(false);

  const selectImageFile = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    setImage(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
      setPackageInfo({...packageInfo, packageImage: reader.result});
    }
    reader.readAsDataURL(file);
  }

  const selectImageFileEn = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    setImageEn(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImageEn(reader.result);
      setPackageInfo({...packageInfo, packageImageEn: reader.result});
    }
    reader.readAsDataURL(file);
  }

  const selectImageFileJp = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    setImageJp(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImageJp(reader.result);
      setPackageInfo({...packageInfo, packageImageJp: reader.result});
    }
    reader.readAsDataURL(file);
  }

  const selectPopImageFile = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    setPopImage(file);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewPopImage(reader.result);
      setPackageInfo({...packageInfo, packagePopImage: reader.result});
    }
    reader.readAsDataURL(file);
  }

  const deletePopImageHandler = () => {
    setPopImage(null);
    setPreviewPopImage(null);
    setPackageInfo({...packageInfo, packagePopImage: null});
    setPopImageDeleted(true);

    // fileクリア
    const file = document.getElementById('oripa-pop-image');
    file.value = '';
  }

  const saveHandler = (e) => {
    e.preventDefault();
    
    savePackageInfo();
  }

  const savePackageInfo = () => {
    const body = new FormData();
    if (packageInfo.packageId)
      body.append('id', packageInfo.packageId);

    body.append('type', packageInfo.packageType);
    body.append('name', packageInfo.packageName);
    body.append('price', packageInfo.packagePrice);
    body.append('number', packageInfo.packageNumber);
    if(packageInfo.packageHiddenFrom)
      body.append('hidden_from', packageInfo.packageHiddenFrom);
    if(packageInfo.packageDisplayFourthRank)
      body.append('display_fourth_rank', 1);
    if (packageInfo.packageStartAt)
      body.append('start_at', packageInfo.packageStartAt + ' 00:00:00');
    if (packageInfo.packageEndAt)
      body.append('end_at', packageInfo.packageEndAt + ' 23:59:59');
    if (image)
      body.append('image', image);
    if (imageEn)
      body.append('image_en', imageEn);
    if (imageJp)
      body.append('image_jp', imageJp);
    if (popImage)
      body.append('pop_image', popImage);
    if (popImageDeleted)
      body.append('pop_image_deleted', 1);
    if(packageInfo.effectType)
      body.append('effect_type', packageInfo.effectType)
    if(packageInfo.limitedNumberPerUserPerDay)
      body.append('limited_number_per_user_per_day', packageInfo.limitedNumberPerUserPerDay)
    if(packageInfo.limitedNumberPerUser)
      body.append('limited_number_per_user', packageInfo.limitedNumberPerUser)

    body.append('priority', packageInfo.packagePriority);
    
    body.append('max_number_per_one_draw', packageInfo.maxNumberPerOneDraw);
    if(packageInfo.dependsOnHoldPoints)
      body.append('depends_on_hold_points', 1);

    if(packageInfo.isEnabledAllDraw)
      body.append('is_enabled_all_draw', 1);
    
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/package/register`, {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      body,
    })
    .then(res => {
      if (res.status === 200 || res.status === 422 || res.status === 400) {
        return res.json()
      } else {
        throw new Error(t('new_oripa_general.error'));
      }
    })
    .then(data => {
      if (data.errors) {
        alert(Object.values(data.errors)[0]);
        return;
      }
      setPackageInfo({...packageInfo, packageId: data.id});
      if (id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6) {
        setModalIsOpen(true);
      } else {
        moveNewOripaSelectCard();
      }
    })
    .catch(err => {
      alert(err.message);
    });
  }

  useEffect(() => {
    if (packageInfo.packageId) {
      fetch(`${process.env.REACT_APP_API_URL}/api/package/${packageInfo.packageId}`, {
        method: 'GET',
        credentials: 'include',
      })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        } else {
          throw new Error(t('new_oripa_general.error'));
        }
      })
      .then(data => {
        setPackageInfo({
          ...packageInfo,
          packageType: data.package.type ? data.package.type : 1,
          packageName: data.package.name,
          packagePrice: data.package.price,
          packageNumber: data.package.number,
          packageHiddenFrom: data.package.hidden_from ? data.package.hidden_from : "",
          packageStartAt: data.package.start_at.split(' ')[0],
          packageEndAt: data.package.end_at.split(' ')[0],
          packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
          packageImageEn: data.package.image_url_en ? process.env.REACT_APP_ASSET_URL + data.package.image_url_en : "",
          packageImageJp: data.package.image_url_jp ? process.env.REACT_APP_ASSET_URL + data.package.image_url_jp : "",
          packagePopImage: data.package.pop_image_url ? process.env.REACT_APP_ASSET_URL + data.package.pop_image_url : "",
          packageStatus: data.package.status,
          packageDisplayFourthRank: data.package.display_fourth_rank === 1 ? true : false,
          effectType: data.package.effect_pattern ? data.package.effect_pattern : 1,
          packagePriority: data.package.priority,
          limitedNumberPerUserPerDay: data.package.limited_number_per_user_per_day ? data.package.limited_number_per_user_per_day : "",
          limitedNumberPerUser: data.package.limited_number_per_user ? data.package.limited_number_per_user : "",
          maxNumberPerOneDraw: data.package.max_number_per_one_draw ? data.package.max_number_per_one_draw : 10,
          dependsOnHoldPoints: data.package.depends_on_hold_points ? data.package.depends_on_hold_points : false,
          isEnabledAllDraw: data.package.is_enabled_all_draw ? data.package.is_enabled_all_draw : false,
        });
        setPreviewImage(process.env.REACT_APP_ASSET_URL+data.package.image_url);
        if (data.package.image_url_en) {
          setPreviewImageEn(process.env.REACT_APP_ASSET_URL+data.package.image_url_en);
        }
        if (data.package.image_url_jp) {
          setPreviewImageJp(process.env.REACT_APP_ASSET_URL+data.package.image_url_jp);
        }
        if (data.package.pop_image_url) {
          setPreviewPopImage(process.env.REACT_APP_ASSET_URL+data.package.pop_image_url);
        }
      })
      .catch(err => {
        alert(err.message);
      });
    } else {
      setPreviewImage(null);
      setPreviewImageEn(null);
      setPreviewImageJp(null);
    }
  }, [packageInfo.packageId]);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
      if (xsrfToken) {
          xsrfToken = xsrfToken.split('=')[1]
      }
      let token = document.cookie.split('; ').find(row => row.startsWith('token'));
      if (token) {
          token = token.split('=')[1]
      }
      fetch(`${process.env.REACT_APP_API_URL}/api/package/${id}`, {
        method: 'GET',
        headers: {
          'X-XSRF-TOKEN': xsrfToken,
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include'
      })
      .then(res => res.json())
      .then(data => {
        setPackageInfo({
          packageId: data.package.id,
          packageType: data.package.type ? data.package.type : 1,
          packageName: data.package.name,
          packagePrice: data.package.price,
          packageNumber: data.package.number,
          packageHiddenFrom: data.package.hidden_from ? data.package.hidden_from : "",
          packageStartAt: data.package.start_at.split(' ')[0],
          packageEndAt: data.package.end_at.split(' ')[0],
          packageImage: process.env.REACT_APP_ASSET_URL + data.package.image_url,
          packageImageEn: data.package.image_url_en ? process.env.REACT_APP_ASSET_URL + data.package.image_url_en : "",
          packageImageJp: data.package.image_url_jp ? process.env.REACT_APP_ASSET_URL + data.package.image_url_jp : "",
          packagePopImage: data.package.pop_image_url ? process.env.REACT_APP_ASSET_URL + data.package.pop_image_url : "",
          packageStatus: data.package.status,
          packageDisplayFourthRank: data.package.display_fourth_rank === 1 ? true : false,
          effectType: data.package.effect_pattern ? data.package.effect_pattern : 1,
          packagePriority: data.package.priority,
          limitedNumberPerUserPerDay: data.package.limited_number_per_user_per_day ? data.package.limited_number_per_user_per_day : "",
          limitedNumberPerUser: data.package.limited_number_per_user ? data.package.limited_number_per_user : "",
          maxNumberPerOneDraw: data.package.max_number_per_one_draw ? data.package.max_number_per_one_draw : 10,
          dependsOnHoldPoints: data.package.depends_on_hold_points ? data.package.depends_on_hold_points : false,
          isEnabledAllDraw: data.package.is_enabled_all_draw ? data.package.is_enabled_all_draw : false,
        });
        setPreviewImage(process.env.REACT_APP_ASSET_URL+data.package.image_url);
        if (data.package.pop_image_url) {
          setPreviewPopImage(process.env.REACT_APP_ASSET_URL+data.package.pop_image_url);
        }
        
      })
      .catch(err => {
        console.log(err);
      });
    }
  }, [id]);
      
  const [effects, setEffects] = useState([]);

  const updateEffects = (originals) => {
    if (packageInfo.effectType === "") {
      if (shopInfo.effectType <= 1000) {
        setEffects([
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-1.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-2.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-3.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-4.mp4`,
        ]);
      } else {
        if (originals) {
          const original = originals.find(o => o.id === Number(shopInfo.effectType));
          if (original) {
            setEffects([
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 1)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 2)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 3)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 4)?.path_with_version}`,
            ]);
          }
        }
      }
    } else {
      if (packageInfo.effectType <= 1000) {
        setEffects([
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${packageInfo.effectType}-1.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${packageInfo.effectType}-2.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${packageInfo.effectType}-3.mp4`,
          `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${packageInfo.effectType}-4.mp4`,
        ]);
      } else {
        if (originals) {
          const original = originals.find(o => o.id === Number(packageInfo.effectType));
          if (original) {
            setEffects([
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 1)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 2)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 3)?.path_with_version}`,
              `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 4)?.path_with_version}`,
            ]);
          }
        }
      }
    }
  }

  useEffect(() => {
    updateEffects(shopInfo.originalEffectPattern)
  }, [shopInfo, packageInfo.effectType])
      

  return (
    <>
      <Header />
      <SideMenu />
      <div className="oripa">
        <div className="oripa-content">
          {!id ?
            <div className="oripa-title">{t('new_oripa_general.oripa')}</div>
            :
            <div className="oripa-title">{t('new_oripa_general.stock')}</div>
          }
          <div className='clearfix'></div>
          <ul className="progressbar">
            {id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6 ? 
              <>
              <li className="active center">{t('new_oripa_general.all')}</li>
              </>
              :
              <>
              <li className="active">{t('new_oripa_general.all')}</li>
              <li></li>
              <li></li>
              </>
            }
          </ul>
          <div className='clearfix'></div>
          <dl className="oripa-info">
            <dt className="oripa-info-title">{t('new_oripa_general.kind')}</dt>
            <dd className="oripa-info-text">
            {id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6 ? 
                <>
                  {packageTypeList.map((packageType, index) => {
                    if (packageInfo.packageType.toString() === packageType.package_type) {
                      return (
                        packageType.package_type_name
                      )
                    }
                  })}
                </>
              :
                <>
                  <select className="oripa-info-select oripa-info-input-long " onChange={(e) => setPackageInfo({...packageInfo, packageType: e.target.value})} value={packageInfo.packageType}>
                    <CreatePackageTypeSelectList />
                  </select>
                </>
            }
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.oripa_name')}</dt>
            <dd className="oripa-info-text">
            {id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6 ? 
                  <>
                    {packageInfo.packageName}
                  </>
                :
                  <>
                    <input className="oripa-info-input-long " type="text" onChange={(e) => setPackageInfo({...packageInfo, packageName: e.target.value})} value={packageInfo.packageName}/>
                  </>
            }
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.price')}</dt>
            <dd className="oripa-info-text">
              <input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, packagePrice: e.target.value})} value={packageInfo.packagePrice}/> {t('new_oripa_general.yen')}/{t('new_oripa_general.card')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.setting')}</dt>
            <dd className="oripa-info-text">
            {id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6 ? 
              <>
                {packageInfo.packageNumber} {t('new_oripa_general.card')}
              </>
              :
              <>
                <input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, packageNumber: e.target.value})}  value={packageInfo.packageNumber}/> {t('new_oripa_general.card')}
              </>
            }
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.limit')}</dt>
            <dd className="oripa-info-text">
              {t('new_oripa_general.times1')}<input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, limitedNumberPerUser: e.target.value})}  value={packageInfo.limitedNumberPerUser} placeholder={t('new_oripa_general.unspecified')}/> {t('new_oripa_general.times2')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.limit_daily')}</dt>
            <dd className="oripa-info-text">
              {t('new_oripa_general.times1')}<input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, limitedNumberPerUserPerDay: e.target.value})}  value={packageInfo.limitedNumberPerUserPerDay} placeholder={t('new_oripa_general.unspecified')}/> {t('new_oripa_general.times2')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.gachas1')}</dt>
            <dd className="oripa-info-text">
              {t('new_oripa_general.gachas2')}<input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, maxNumberPerOneDraw: e.target.value})}  value={packageInfo.maxNumberPerOneDraw} defaultValue="10"/> {t('new_oripa_general.gachas3')}
              <br />
              <input className="oripa-info-input-checkbox" type="checkbox" onChange={(e) => setPackageInfo({...packageInfo, dependsOnHoldPoints: e.target.checked})} checked={packageInfo.dependsOnHoldPoints} /> {t('new_oripa_general.gachas4')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.gachas5')}</dt>
            <dd className="oripa-info-text">
              <input className="oripa-info-input-checkbox" type="checkbox" onChange={(e) => setPackageInfo({...packageInfo, isEnabledAllDraw: e.target.checked})} checked={packageInfo.isEnabledAllDraw} /> {t('new_oripa_general.display')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.display4')}</dt>
            <dd className="oripa-info-text">
              <input className="oripa-info-input-checkbox" type="checkbox" onChange={(e) => setPackageInfo({...packageInfo, packageDisplayFourthRank: e.target.checked})} checked={packageInfo.packageDisplayFourthRank} /> {t('new_oripa_general.display')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.hide1')}</dt>
            <dd className="oripa-info-text">
              {t('new_oripa_general.hide2')}<input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, packageHiddenFrom: e.target.value})} value={packageInfo.packageHiddenFrom} placeholder={t('new_oripa_general.unspecified')} /> {t('new_oripa_general.hide3')}
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.period')}</dt>
            <dd className="oripa-info-text">
              <input className="oripa-info-input" type="date" onChange={(e) => setPackageInfo({...packageInfo, packageStartAt: e.target.value})}  value={packageInfo.packageStartAt}/>
              &nbsp;〜&nbsp; 
              <input className="oripa-info-input" type="date" onChange={(e) => setPackageInfo({...packageInfo, packageEndAt: e.target.value})}  value={packageInfo.packageEndAt}/>
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.pop')}</dt>
            <dd className="oripa-info-text">
              <div className="oripa-info-img">
                {previewImage &&
                  <img src={previewImage} />
                }
              </div>
              <input className="oripa-info-input-long" type="file" onChange={selectImageFile} />
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.pop_en')}</dt>
            <dd className="oripa-info-text">
              <div className="oripa-info-img">
                {previewImageEn &&
                  <img src={previewImageEn} />
                }
              </div>
              <input className="oripa-info-input-long" type="file" onChange={selectImageFileEn} />
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.pop_jp')}</dt>
            <dd className="oripa-info-text">
              <div className="oripa-info-img">
                {previewImageJp &&
                  <img src={previewImageJp} />
                }
              </div>
              <input className="oripa-info-input-long" type="file" onChange={selectImageFileJp} />
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.image')}</dt>
            <dd className="oripa-info-text">
              <div className="oripa-info-pop-img">
                {previewPopImage &&
                  <img src={previewPopImage} />
                }
              </div>
              <input className="oripa-info-input-long" id="oripa-pop-image" type="file" onChange={selectPopImageFile} />
              <button className="oripa-info-button-delete" onClick={deletePopImageHandler}>{t('new_oripa_general.delete')}</button>
            </dd>
            <dt className="shop-info-title">{t('new_oripa_general.effects')}</dt>
            <dd className="shop-info-text">
            <select name="gachaEffect" id="gachaEffect" className="shop-effect-select" onChange={(e) => setPackageInfo({...packageInfo, effectType: e.target.value})} value={packageInfo.effectType}>
                  <option value="">{t('new_oripa_general.default')}</option>
                  <option value="1">{t('new_oripa_general.fireworks')}</option>
                  <option value="2">{t('new_oripa_general.circle')}</option>
                  <option value="3">{t('new_oripa_general.warp')}</option>
                  <option value="4">{t('new_oripa_general.happy')}</option>
                  <option value="5">{t('new_oripa_general.fall')}</option>
                  <option value="6">{t('new_oripa_general.bolt')}</option>
                  <option value="7">{t('new_oripa_general.whirlpool1')}</option>
                  <option value="8">{t('new_oripa_general.whirlpool2')}</option>
                  {shopInfo.originalEffectPattern && shopInfo.originalEffectPattern.map((o, i) => <option key={i} value={o.id}>{o.name}</option>)}
              </select>
              {packageInfo.effectType ?
                <div className="shop-effect-imgs">
                  {effects.map((e, index) => (
                    <div className="shop-effect-img" key={"shop-effect-img"+index}>
                      <video src={e} autoPlay muted loop playsInline></video>
                      {index + 1}{t('new_oripa_general.rank')}
                    </div>
                  ))}
                </div>
                :
                <div className="shop-effect-imgs">
                  {effects.map((e, index) => (
                    <div className="shop-effect-img" key={"shop-effect-img"+index}>
                      <video src={e} autoPlay muted loop playsInline></video>
                      {index + 1}{t('new_oripa_general.rank')}
                    </div>
                  ))}
                </div>
              }
            </dd>
            <dt className="oripa-info-title">{t('new_oripa_general.priority1')}</dt>
            <dd className="oripa-info-text">
              <input className="oripa-info-input" type="text" onChange={(e) => setPackageInfo({...packageInfo, packagePriority: e.target.value})} value={packageInfo.packagePriority} placeholder="1-1000" /> {t('new_oripa_general.priority2')}
            </dd>
          </dl>
          <div className="oripa-info-button">
            {id && packageInfo.packageStatus != 1 && packageInfo.packageStatus != 6 ? 
              <>
                <button className="oripa-info-button-next" onClick={saveHandler}>{t('new_oripa_general.complete1')}</button>
              </>
              :
              <>
                <button className="oripa-info-button-next" onClick={saveHandler}>{t('new_oripa_general.next')}</button>
              </>
            }
          </div>
        </div>
      </div>
      <CommonModal
        modalIsOpen={modalIsOpen}
        message={t('new_oripa_general.complete2')}
        linkMessage={t('new_oripa_general.top')}
        link={`/${shop}/stock`}
      ></CommonModal>
    </>
  )
}

export default NewOripaGeneral